import { Actor, CollisionType, vec } from 'excalibur';

import { Resources } from '../resources';

export class Workshop extends Actor {
  constructor() {
    super({
      name: 'Workshop',
      pos: vec(0, 0),
      anchor: vec(0, 0),
      collisionType: CollisionType.Passive,
      width: 136,
      height: 87,
      z: 5,
    });
  }

  override onInitialize(): void {
    this.graphics.use(Resources.workshop.toSprite());
  }
}
